import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { TOGGLE_CALENDAR } from "src/api/calendar";
import { useDispatch, useSelector } from "react-redux";
import { setNotification } from "src/redux/Notifications/sliceNotifications";
import {
  convertWeekForRequest,
  convertWeekToObject,
} from "src/helpers/calendar/calendarRequests";
import { useStyles } from "./styles";
import { customFormat } from "src/helpers/DateFormat";
import { auth, currentUser } from "src/redux/Authentication/sliceAuthentication";
import {
  calendarDates,
  calendarOptions,
  calendarWeek,
} from "src/redux/Calendar/sliceCalendar";

export const ToggleDialog = ({
  open,
  handleClose,
  action,
}: {
  open: boolean;
  handleClose: () => void;
  action: "open" | "close";
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useSelector(auth);
  const partner_id = +user["custom:partner_id"];
  const { trip_id, type, schedulesIds } = useSelector(calendarOptions);
  const dates = useSelector(calendarDates);
  const week = useSelector(calendarWeek);

  const [toggleCalendar, { loading }] = useMutation(TOGGLE_CALENDAR, {
    onCompleted: ({ v1_activities_toggleCalendar }) => {
      const { success, msg } = v1_activities_toggleCalendar;

      dispatch(
        setNotification({
          message: msg?.length ? msg.join(", \n") : "Data change successfully",
          type: success ? "success" : "error",
        })
      );

      handleClose();
    },
    onError: (error) => {
      dispatch(
        setNotification({
          message: error.message,
          type: "error",
        })
      );
    },
  });

  const date_ranges = dates
    .filter((i) => i.date_from && i.date_to)
    .map(({ date_from, date_to }) => ({ date_from, date_to }));

  const date_string = date_ranges.reduce((acc, curr) => {
    const date =
      customFormat(curr.date_from, "MM/DD/YYYY") +
      " - " +
      customFormat(curr.date_to, "MM/DD/YYYY");

    return (!acc ? "" : acc + ", ") + date;
  }, "");

  const onToggleCalendar = async () => {
    await toggleCalendar({
      variables: {
        prm: {
          trip_id,
          user_id: +partner_id,
          type,
          date_ranges,
          days: week,
          schedules_id: schedulesIds,
          action,
        },
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent style={{ overflow: "inherit" }}>
        <DialogContentText>
          {type === "ticket" ? "All Tickets" : "Selected Schedules"} will be
          {action === "open" ? " activated" : " disabled"} for
          {type === "ticket" && " selected schedules and "} the following
          periods: {date_string}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box p={1} mr={1} marginTop="3px">
          <Button
            onClick={handleClose}
            className={classes.cancelButton}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={() => onToggleCalendar()}
            className={classes.saveButton}
            variant="contained"
          >
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "26px", height: "26px" }}
              />
            ) : (
              "Save"
            )}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
